import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'icon-time',
  templateUrl: './icon-time.component.html',
  styles: []
})
export class IconTimeComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}
